import React from "react";

interface ImageUploadProps {
  imageUrl: string;
  onImageChange: (file: any) => void;
  onImageRemove?: () => void;
  isForSharing: boolean;
  placeholderImage?: string;
  sectionName?: string;
  canWrite?: boolean;
  canDelete?: boolean;
}

const ImageUpload: React.FC<ImageUploadProps> = ({
  imageUrl,
  onImageChange,
  onImageRemove,
  isForSharing,
  placeholderImage,
  sectionName,
  canWrite = false,
  canDelete = false,
}) => {
  const handleImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const allowedTypes = ["image/jpg", "image/jpeg", "image/png", "image/svg+xml", "image/webp"];
    const maxSizeInMB = 110;

    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      console.log("Selected file In Landing Page:", file);
      if (!allowedTypes.includes(file.type)) {
        alert("Please upload a valid image file (JPG, JPEG, PNG, SVG and WEBP).");
        return;
      }

      const fileSizeInMB = file.size / (1024 * 1024);
      if (fileSizeInMB > maxSizeInMB) {
        alert(`File size should not exceed 100MB.`);
        return;
      }

      onImageChange(file);
    }
  };

  return (
    <div
      style={{
        height: 400,
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: isForSharing ? "default" : "pointer",
        position: "relative",
        overflow: "hidden",
      }}
      id={`image-upload-container-${sectionName}`}
    >
      {imageUrl ? (
        <>
          <img
            src={imageUrl}
            id={`${sectionName}`}
            key={`${sectionName}`}
            alt="Uploaded"
            style={{
              maxHeight: "100%",
              maxWidth: "100%",
              width: "100%",
              height: "400px",
              objectFit: "cover",
            }}
          />

          {!isForSharing && (
            <div
              style={{
                position: "absolute",
                top: 10,
                right: 15,
                display: "flex",
                flexDirection: "row",
                gap: "10px",
              }}
            >
              <input
                id={`change-file-input-${sectionName}`}
                type="file"
                accept="image/png, image/jpg, image/jpeg, image/webp"
                onChange={handleImageChange}
                style={{ display: "none", fontFamily: "Roboto, sans-serif" }}
                disabled={!canWrite}
              />
              <label
                htmlFor={`change-file-input-${sectionName}`}
                style={{
                  background: "#FFFFFF",
                  padding: "10px 10px",
                  boxShadow: "0 0 8px 0 #00000040",
                  borderRadius: "8px",
                  fontSize: "12px",
                  cursor: `${canWrite ? "pointer" : "not-allowed"}`,
                  color: canWrite ? "#212121" : "rgba(16, 16, 16, 0.3)",
                }}
              >
                Change Image
              </label>

              <button
                onClick={onImageRemove}
                style={{
                  background: "#FFFFFF",
                  padding: "10px 10px",
                  boxShadow: "0 0 8px 0 #00000040",
                  borderRadius: "8px",
                  fontSize: "12px",
                  cursor: `${canWrite ? "pointer" : "not-allowed"}`,
                  color: canWrite ? "#212121" : "rgba(16, 16, 16, 0.3)",
                  border: "none",
                  fontFamily: "Roboto, sans-serif",
                }}
                disabled={!canWrite}
              >
                Remove
              </button>
            </div>
          )}
        </>
      ) : (
        !isForSharing && (
          <>
            <input
              id={`file-input-${sectionName}`}
              type="file"
              accept="image/png, image/jpg, image/jpeg, image/webp"
              onChange={handleImageChange}
              style={{ display: "none" }}
              disabled={!canWrite}
            />
            <label
              htmlFor={`file-input-${sectionName}`}
              style={{
                cursor: canWrite ? "pointer" : "not-allowed",
                textAlign: "center",
              }}
            >
              <img
                src={placeholderImage}
                alt="Add"
                style={{ maxWidth: "80px" }}
              />
              <h5
                style={{
                  color: canWrite ? "#1194DA" : "rgba(16, 16, 16, 0.3)",
                  textDecoration: "underline",
                }}
              >
                Add Image
              </h5>
            </label>
          </>
        )
      )}
    </div>
  );
};

export default ImageUpload;
